import {validateSchema} from 'app/common/validations';
import reduceReducers from 'reduce-reducers';
import update from 'immutability-helper';
import * as api from 'app/client/api';
import {showAppBusy, handleAppError} from './app';
import I18n from 'app/common/i18n';
import {history} from 'store';
import * as routePath from 'app/utils/routePath';

const SCHEMA_ID = 'dk-admin/changePassword';
const initialState = {
  profile: {},
  password: {
    old: null,
    newPassword: null,
    confirm: null
  },
  email: '',
  errors : {
    validation: null,
    password : null
  }
}

const RECEIVE_PROFILE_INFO = "profile/RECEIVE_PROFILE_INFO";
const UPDATE_OLD_PASSWORD = "profile/UPDATE_OLD_PASSWORD";
const UPDATE_NEW_PASSWORD = "profile/UPDATE_NEW_PASSWORD";
const UPDATE_CONFIRM_NEW_PASSWORD = "profile/UPDATE_CONFIRM_NEW_PASSWORD";
const PASSWORD_CHANGE_SUCCESS = "profile/PASSWORD_CHANGE_SUCCESS";
const PASSWORD_CHANGE_FAIL = "profile/PASSWORD_CHANGE_FAIL";

export function receiveProfileInfo(payload) {
  return { type: RECEIVE_PROFILE_INFO, payload }
}

export function updateOldPassword(payload) {
  return { type: UPDATE_OLD_PASSWORD, payload }
}

export function updateNewPassword(payload) {
  return { type: UPDATE_NEW_PASSWORD, payload }
}
export function updateConfirmNewPassword(payload) {
  return { type: UPDATE_CONFIRM_NEW_PASSWORD, payload }
}

export function passwordChangeFail(payload) {
  return { type: PASSWORD_CHANGE_FAIL, payload }
}
export function passwordChangeSucces() {
  return { type: PASSWORD_CHANGE_SUCCESS, payload: initialState }
}

export function fetchProfileInfo() {
  return async (dispatch, getState) => {
    
    try {
      let response = await api.fetchAcademyProfile();
      dispatch(receiveProfileInfo(response.data))
    } catch(exception) {
        dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
    }
  }
}

export function changePassword() {
  return async (dispatch, getState) => {
    let {old, newPassword, confirm} = getState().profile.password
    let req = {
      oldPassword: old,
      newPassword: newPassword,
      confirmPassword: confirm
    }
    try {
      await api.changePassword(req);
      dispatch(passwordChangeSucces());
      history.push(routePath.dashboardRoute);
    } catch(exception) {
      let stateErrorHandler = (errorResponse) => {
        let errorMessage = (errorResponse.data && errorResponse.data.message) ? errorResponse.data.message : I18n.t('errors.unexpected');
        dispatch(passwordChangeFail(errorMessage));
      };
      dispatch(handleAppError(exception, I18n.t('errors.unexpected'), stateErrorHandler));
    }
  }
}


export function resetPassword(token) {
  return async (dispatch, getState) => {
    dispatch(showAppBusy(true));
    let {newPassword, confirm} = getState().profile.password;
    let req = {
      newPassword: newPassword,
      confirmPassword: confirm,
      token: token
    }
    try {
      await api.resetPassword(req);
      dispatch(passwordChangeSucces());
      history.push(routePath.rootRoute);
      dispatch(showAppBusy(false));
    } catch(exception) {
      dispatch(showAppBusy(false));
      let stateErrorHandler = (errorResponse) => {
        let errorMessage = (errorResponse.data && errorResponse.data.message) ? errorResponse.data.message : I18n.t('errors.unexpected');
        dispatch(passwordChangeFail(errorMessage));
      };
      dispatch(handleAppError(exception, I18n.t('errors.unexpected'), stateErrorHandler));
    }
  }
}

function validator(state = initialState, action)  {
  let {type} = action;
  switch(type)  {
    case UPDATE_OLD_PASSWORD:
    case UPDATE_NEW_PASSWORD:
    case UPDATE_CONFIRM_NEW_PASSWORD:
      let validationErrors = validateSchema(state.password, SCHEMA_ID);
      return update(state, { errors: { validation: {$set: validationErrors }}});

    default:
      return state;
  }
}

function reducer(state = initialState, action) {
  let { payload, type } = action;
  switch(type)  {
    case RECEIVE_PROFILE_INFO:
      return update(state, {profile: {$set: payload}});
    
    case UPDATE_OLD_PASSWORD:
      return update(state, {password: { old: { $set: payload }}});

    case UPDATE_NEW_PASSWORD:
      return update(state, {password: { newPassword: { $set: payload }}});

    case UPDATE_CONFIRM_NEW_PASSWORD:
      return update(state, {password: { confirm: { $set: payload }}});

    case PASSWORD_CHANGE_FAIL:
      return update(state, { errors: { password: { $set: payload }}});

    case PASSWORD_CHANGE_SUCCESS:
      return update(state, { 
        errors: { $set: payload.errors}, 
        password: { $set: payload.password}, 
        email: { $set: payload.email}
      });

    default:
      return state;
  }
}

export default reduceReducers(
  reducer,
  validator,
)


// WEBPACK FOOTER //
// ./src/reducers/profile.js